import { FETCH_START, FETCH_END, TABLE_LIST } from './ActionTypes';
import axios from '../../../../axios.conf';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const getAllEditableTables = (param) => {
  return (dispatch) => {
    dispatch(fetchStart())
    getAllEditableTablesApi(param)
      .then((response) => {
        dispatch(getTableList(response.data.response))
        dispatch(fetchEnd())
      })
      .catch((error) => {
        dispatch(fetchEnd())
      });
  };
};

export const getAllEditableTablesApi = (param) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/get-table-names', { params: param, headers: headers });
  return result;
};
export const getTableList = (data) => {
  return {
    type: TABLE_LIST,
    data,
  };
};
export const clearData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart())
    clearDataAPI(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd())
      })
      .catch((error) => {
        dispatch(fetchEnd())
      });
  };
};

const clearDataAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('generic-delete', data, { headers: headers });
  return result;
};
